module.exports = __webpack_public_path__ + "static/media/33.539cd427.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/33.png
// module id = 994
// module chunks = 0